module.exports = __webpack_public_path__ + "static/media/6.3c6c8316.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/6.png
// module id = 1245
// module chunks = 0